import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './services/i18n';
import { store } from './app/store';
import { Provider } from 'react-redux';

import axiosInterceptors from './services/axiosInterceptors';

import 'moment/locale/hu';
import 'moment/locale/sr';
// import 'moment/locale/uk';

import App from './App';

import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Loader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100vh',
        alignItems: 'center',
      }}
    >
      {/* <Box sx={{ mb: 2, fontSize: '2em' }}>Loading...</Box> */}
      <CircularProgress sx={{ color: '#576b0a' }} size={'80px'} />
    </Box>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <App /> */}
    <React.Suspense fallback={<Loader />}>
      <Provider store={store}>
        <App />
      </Provider>
    </React.Suspense>
  </React.StrictMode>
);

axiosInterceptors(store);
